"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareExportData = void 0;
var isColumnWithTransform = function (column) {
    return 'transform' in column;
};
var getHeadersForColumns = function (columns) {
    return columns.map(function (column) { return column.title; });
};
var getDefaultItemSortFunction = function (columns) {
    if (!columns.length)
        return function () { return 0; };
    var firstColumnKey = columns[0].dataKey;
    if (firstColumnKey === null)
        return function () { return 0; };
    return function (a, b) {
        return a[firstColumnKey] > b[firstColumnKey] ? 1 : -1;
    };
};
var transformData = function (items, columns) {
    return items.map(function (item) {
        return columns.map(function (column) {
            var dataKey = column.dataKey, defaultValue = column.defaultValue;
            var rawValue = dataKey ? item[dataKey] : undefined;
            var value = rawValue;
            if (isColumnWithTransform(column)) {
                var transform = column.transform;
                var rawValue_1 = dataKey !== null && item[dataKey];
                value = transform(rawValue_1, item);
            }
            if (!value)
                value = defaultValue;
            return value;
        });
    });
};
var aggregateData = function (items, columns) {
    return columns.reduce(function (agg, column) {
        var _a, _b;
        if (!column.aggregation)
            return agg;
        var key, value;
        if (isColumnWithTransform(column)) {
            (_a = column.aggregation(items, column), key = _a.key, value = _a.value);
        }
        else {
            (_b = column.aggregation(items, column), key = _b.key, value = _b.value);
        }
        agg[key] = value;
        return agg;
    }, {});
};
var getFormatting = function (columns) {
    return columns.map(function (column) { return column.format || 'str'; });
};
var getColumnWidthsBasedOnContent = function (items, columns) {
    return columns.map(function (column) {
        var charsCountInColumn = items.map(function (item) {
            var value = column.dataKey !== null && item[column.dataKey];
            if (!value)
                return 0;
            return String(value).length;
        });
        return Math.max.apply(Math, __spreadArray([], __read(__spreadArray(__spreadArray([], __read(charsCountInColumn), false), [column.title.length], false)), false));
    });
};
var prepareExportData = function (columns, data, dataSortFunction, customCalculateColumnsWidthFunction) {
    var headers = getHeadersForColumns(columns);
    var sortFunction = dataSortFunction || getDefaultItemSortFunction(columns);
    var sortedItems = data.sort(sortFunction);
    var rowData = transformData(sortedItems, columns);
    var formatting = getFormatting(columns);
    var calculateWidthsFunction = customCalculateColumnsWidthFunction || getColumnWidthsBasedOnContent;
    var columnWidths = calculateWidthsFunction(sortedItems, columns);
    var aggregations = aggregateData(data, columns);
    return { headers: headers, data: rowData, formatting: formatting, columnWidths: columnWidths, aggregations: aggregations };
};
exports.prepareExportData = prepareExportData;
